import {
    ADD_ITEMS_TO_QUEUE,
    CLEAR_QUEUE_PROGRESS, REMOVE_ITEMS_FROM_QUEUE,
    UPDATE_QUEUE_PROGRESS,
    UPDATE_SHOW_DOWNLOAD_MANAGER
} from './types';

export const removeItemsFromQueue = (itemsToRemove = [], closeManager = false) => dispatch => {
    if (itemsToRemove) {
        itemsToRemove.forEach(itemToRemove => {
            if (itemToRemove.xhr && itemToRemove.abortController) {
                itemToRemove.abortController.abort('Aborted by user interaction (remove)');
                console.log('Removed "' + itemToRemove.url + '"');
            }
        })
    }
    dispatch({
        type: REMOVE_ITEMS_FROM_QUEUE,
        payload: {
            itemsToRemove,
            closeManager
        }
    });
}

export const clearQueueProgress = (itemsToClear = [], closeManager = false) => dispatch => {
    if (itemsToClear) {
        itemsToClear.forEach(itemToClear => {
            if (itemToClear.xhr && itemToClear.abortController) {
                itemToClear.abortController.abort('Aborted by user interaction (cancel)');
                console.log('Cancelled "' + itemToClear.url + '"');
            }
        })
    }
    dispatch({
        type: CLEAR_QUEUE_PROGRESS,
        payload: {
            itemsToClear,
            closeManager
        }
    });
}

export const resetQueueProgress = (itemsToReset = []) => dispatch => {
    // TODO: devo dividerlo in 3 flussi distinti: prima uno che setta refresh a true, poi uno che fa l'abort e quindi uno che lo refresha
    let itemsToActuallyReset = [];
    if (itemsToReset) {
        itemsToReset.forEach(itemToReset => {
            if (itemToReset.xhr && itemToReset.abortController) {
                itemToReset.abortController.abort('Aborted by user interaction (refresh)');
                console.log('Refreshed "' + itemToReset.url + '"');
            }
            itemToReset['refresh'] = true;
            itemsToActuallyReset.push(itemToReset);
        })
    }
    dispatch({
        type: CLEAR_QUEUE_PROGRESS,
        payload: itemsToActuallyReset
    });
}

export const refreshItemsInQueue = (itemsToRefresh = []) => dispatch => {
    let itemsToActuallyRefresh = [];
    if (itemsToRefresh) {
        itemsToRefresh.forEach(itemToRefresh => {
            // lo pulisco
            delete itemToRefresh['xhr'];
            delete itemToRefresh['abortController'];
            delete itemToRefresh['pending'];
            delete itemToRefresh['progress'];
            delete itemToRefresh['refresh'];
            delete itemToRefresh['status'];
            delete itemToRefresh['statusText'];
            itemsToActuallyRefresh.push(itemToRefresh);
        });
    }
    dispatch({
        type: ADD_ITEMS_TO_QUEUE,
        payload: itemsToActuallyRefresh
    });
}

export const addItemsToQueue = (queueItems) => dispatch => {
    // rimuovo i doppioni in queueItems
    let newQueue = [];
    queueItems.forEach(queueItem => {
        const indexInQueue = newQueue.findIndex(el => el.url === queueItem.url);
        if (indexInQueue < 0) {
            newQueue.push(queueItem);
        }
    });
    dispatch({
        type: ADD_ITEMS_TO_QUEUE,
        payload: newQueue
    });
};

export const updateQueueProgress = (queueProgress) => dispatch => {
    dispatch({
        type: UPDATE_QUEUE_PROGRESS,
        payload: queueProgress
    });
}

export const updateShowDownloadManager = (show) => dispatch => {
    dispatch({
        type: UPDATE_SHOW_DOWNLOAD_MANAGER,
        payload: show
    });
};
